import React from "react";
import {
	EORB3RecordCode,
	TORB3BackendRecord,
	TORB3Record,
} from "redux/app/orb3/@types";
import ORB3GroupA1Preview from "./previews/ORB3GroupA1Preview";
import ORB3GroupA2Preview from "./previews/ORB3GroupA2Preview";
import ORB3GroupA3Preview from "./previews/ORB3GroupA3Preview";
import ORB3GroupA4Preview from "./previews/ORB3GroupA4Preview";
import ORB3GroupA5Preview from "./previews/ORB3GroupA5Preview";
import ORB3GroupB1Preview from "./previews/ORB3GroupB1Preview";
import ORB3GroupB2Preview from "./previews/ORB3GroupB2Preview";
import ORB3GroupB3Preview from "./previews/ORB3GroupB3Preview";
import ORB3GroupC3Preview from "./previews/ORB3GroupC3Preview";
import ORB3GroupC4_1Preview from "./previews/ORB3GroupC4_1Preview";
import ORB3GroupC4_2Preview from "./previews/ORB3GroupC4_2Preview";
import ORB3GroupC4_3Preview from "./previews/ORB3GroupC4_3Preview";
import ORB3GroupD5Preview from "./previews/ORB3GroupD5Preview";
import ORB3GroupEPreview from "./previews/ORB3GroupEPreview";
import ORB3GroupF1Preview from "./previews/ORB3GroupF1Preview";
import ORB3GroupF2Preview from "./previews/ORB3GroupF2Preview";

type OwnProps = {
	record: TORB3Record | TORB3BackendRecord;
	theme?: "light" | "dark";
};

function ORB3Previewer(props: OwnProps) {
	const { record, theme } = props;

	function renderRows() {
		switch (record.recordCode) {
			case EORB3RecordCode.ORB3_A1:
				return <ORB3GroupA1Preview orb3Record={record} theme={theme} />;
			case EORB3RecordCode.ORB3_A2:
				return <ORB3GroupA2Preview orb3Record={record} theme={theme} />;
			case EORB3RecordCode.ORB3_A3:
				return <ORB3GroupA3Preview orb3Record={record} theme={theme} />;
			case EORB3RecordCode.ORB3_A4:
				return <ORB3GroupA4Preview orb3Record={record} theme={theme} />;
			case EORB3RecordCode.ORB3_A5:
				return <ORB3GroupA5Preview orb3Record={record} theme={theme} />;
			case EORB3RecordCode.ORB3_B1:
				return <ORB3GroupB1Preview orb3Record={record} theme={theme} />;
			case EORB3RecordCode.ORB3_B2:
				return <ORB3GroupB2Preview orb3Record={record} theme={theme} />;
			case EORB3RecordCode.ORB3_B3:
				return <ORB3GroupB3Preview orb3Record={record} theme={theme} />;
			case EORB3RecordCode.ORB3_C3:
				return <ORB3GroupC3Preview orb3Record={record} theme={theme} />;
			case EORB3RecordCode.ORB3_C4_1:
				return <ORB3GroupC4_1Preview orb3Record={record} theme={theme} />;
			case EORB3RecordCode.ORB3_C4_2:
				return <ORB3GroupC4_2Preview orb3Record={record} theme={theme} />;
			case EORB3RecordCode.ORB3_C4_3:
				return <ORB3GroupC4_3Preview orb3Record={record} theme={theme} />;
			case EORB3RecordCode.ORB3_D5:
				return <ORB3GroupD5Preview orb3Record={record} theme={theme} />;
			case EORB3RecordCode.ORB3_E:
				return <ORB3GroupEPreview orb3Record={record} theme={theme} />;
			case EORB3RecordCode.ORB3_F1:
				return <ORB3GroupF1Preview orb3Record={record} theme={theme} />;
			case EORB3RecordCode.ORB3_F2:
				return <ORB3GroupF2Preview orb3Record={record} theme={theme} />;
			default:
				return null;
		}
	}

	return <>{renderRows()}</>;
}

export default ORB3Previewer;
